/**
 * Created by or_p on 7/4/2016.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';

const styles = {
  'paddingTop': {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)'
  },
  'paddingLeft': {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  'paddingRight': {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  'paddingBottom': {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)'
  },
  container: {
    position: 'relative',
    justifyContent: 'center',
    height: 120,
    width: '100%',
  }
};

export default class CustomBorderRadiusInput extends Component {

  constructor(props) {
    super();
    const {defaultValue} = props;
    this.state = {...defaultValue};
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.defaultValue, this.props.defaultValue)) {
      this.setState({...nextProps.defaultValue});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {onChange} = this.props;
    if (!_.isEqual(prevState, this.state) && !_.isEqual(this.state, this.props.defaultValue)) {
      onChange(this.state);
    }
  }

  render() {
    return (
      <div style={styles.container}>
        {
          PADDING_PROP_NAMES.map((paddingPropName) => {
            return (
              <SelectField
                value={this.state[paddingPropName]}
                style={{width: '45%', textAlign: 'center', ...styles[paddingPropName]}}
                key={paddingPropName} onChange={(event, index, value) => {this.setState({[paddingPropName]: value});}}
                maxHeight={false}
              >
                {
                  _.range(0, 75, 5).map((value) => {
                    return <MenuItem value={`${value}px`} primaryText={`${value}px`} style={{textAlign: 'center'}}/>;
                  })
                }
              </SelectField>
            );
          })
        }
      </div>
    );
  }
}

CustomBorderRadiusInput.propTypes = {
  defaultValue: PropTypes.shape(_.zipObject(PADDING_PROP_NAMES, _.times(PADDING_PROP_NAMES.length, _.constant(PropTypes.string.isRequired)))).isRequired,
  onChange: PropTypes.func.isRequired,
};